export default {
  gender: [
    { id: 1, title: 'مرد' },
    { id: 0, title: 'زن' }
  ],
  licenseType: [
    { id: 1, title: '1' },
    { id: 2, title: '2' }
  ]
}
